import { initializeFirestore } from "firebase/firestore";
import { AsyncDebugProvider, AsyncValidationProvider, CacheProvider } from "shelving";
import { FirestoreClientProvider } from "shelving/firestore/client";
import { createDataContext } from "shelving/react";
import { FIREBASE_APP } from "shared/firebase/app";
import { SCHEMAS, type Schemas } from "shared/schema";

// Keep a local in-memory cache of validated Firestore data to drive the React integration.
export const CACHE = new CacheProvider<Schemas>(
	// Validate all data sent to or received from Firestore using our schemas.
	new AsyncValidationProvider<Schemas>(
		// Everything in/out of Firestore is validated against our schemas.
		SCHEMAS,
		// Firestore is the original data source.
		new FirestoreClientProvider<Schemas>(initializeFirestore(FIREBASE_APP, {})),
	),
);

/** The memory database that powers our in-memory cache. */
export const MEMORY = CACHE.memory;

// Create database.
export const DB =
	// Log all get/set/update/delete requests to the console.
	// @todo remove this for production.
	new AsyncDebugProvider<Schemas>(CACHE);

// Create a data context to access the database in React components.
const { useItem, useQuery, DataContext } = createDataContext<Schemas>(DB);
export { useItem, useQuery, DataContext };
